import { render } from "./DeletePopup.vue?vue&type=template&id=1c1dadfc&scoped=true"
import script from "./DeletePopup.vue?vue&type=script&lang=js"
export * from "./DeletePopup.vue?vue&type=script&lang=js"

import "./DeletePopup.vue?vue&type=style&index=0&id=1c1dadfc&scoped=true&lang=scss"

import exportComponent from "/Users/eduardopassos/Documents/Dev/blat/subsextract/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1dadfc"]])

export default __exports__